import React from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import PropTypes from 'prop-types'
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles'
import withStyles from '@material-ui/core/styles/withStyles'
import CssBaseline from '@material-ui/core/CssBaseline'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import { withTranslate } from 'react-redux-multilingual'
import CustomAppBar from './CustomAppBar'
import PaymentStep from './PaymentStep'

class Payment extends React.Component {
  render() {
    const { classes } = this.props
    const { paymentInfo } = this.props

    return (
      <React.Fragment>
        <MuiThemeProvider theme={theme}>
          <CssBaseline />
          <CustomAppBar />
          <main className={classes.layout}>
            <Paper className={classes.paper}>
              <Grid item xs={12} sm={12} className={classes.grid}>
                <PaymentStep paymentInfo={paymentInfo} />
              </Grid>
            </Paper>
          </main>
        </MuiThemeProvider>
      </React.Fragment>
    )
  }
}

const styles = (theme) => ({
 layout: {
    width: 'auto',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    [theme.breakpoints.up(670 + theme.spacing(4))]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    backgroundColor: '#fff'
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(670 + theme.spacing(6))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    },
    backgroundColor: '#fff'
  },
  grid: {
    paddingTop: '0px!important'
  },
})

const theme = createTheme({
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    useNextVariants: true
  },
  palette: {
    primary: {
      main: '#455A64'
    },
    secondary: {
      light: '#0066ff',
      main: '#0044ff',
      contrastText: '#ffcc00'
    }
  }
})

Payment.propTypes = {
  classes: PropTypes.object.isRequired
}

export default compose(withStyles(styles), connect())(withTranslate(Payment))
